import { ErrorContent as AntdErrorContent, Skeleton as AntdSkeleton, Spin } from '@yimoka/antd';
import type { PropsWithChildren } from 'react';

/** Loading 为运行时页面提供最小加载占位，复杂流程使用保留品牌过渡的 GlobalLoading。 */
export function Loading({ loading = true, children }: PropsWithChildren<{ loading?: boolean }>) {
  if (!loading) return children;
  return <Spin />;
}

/** Skeleton 为局部数据区域保留组件库骨架屏，避免阻塞整个页面的交互。 */
export function Skeleton({ loading = true, children }: PropsWithChildren<{ loading?: boolean }>) {
  return <AntdSkeleton active loading={loading}>{children}</AntdSkeleton>;
}

/**
 * 沿用旧版已沉淀在组件库中的 Exception 图文错误态，避免业务端退化成裸 Alert。
 * EntityResponse 仍通过当前 ConfigProvider 注入，不复制旧版请求或 Store 行为。
 */
export const ErrorContent = AntdErrorContent;
